/*
 * 模块: Design Tokens - Effects
 * 职责: 视觉效果定义（圆角、阴影、模糊）
 * 依赖: 无
 * 导出: effects
 * 限制: 文件<150行
 */

/**
 * 圆角半径
 */
export const borderRadius = {
  /** 0px - 无圆角 */
  none: '0',
  /** 2px - 极小圆角 */
  xs: '2px',
  /** 4px - 小圆角 */
  sm: '4px',
  /** 8px - 标准圆角 */
  base: '8px',
  /** 12px - 中等圆角 */
  md: '12px',
  /** 16px - 大圆角 */
  lg: '16px',
  /** 20px - 超大圆角 */
  xl: '20px',
  /** 24px - 特大圆角 */
  '2xl': '24px',
  /** 9999px - 完全圆形 */
  full: '9999px',
} as const;

/**
 * 盒阴影（4级深度系统）
 */
export const boxShadow = {
  /** 无阴影 */
  none: 'none',
  /** 层级1 - 轻微浮起 */
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  /** 层级2 - 标准卡片 */
  base: '0 2px 8px rgba(0, 0, 0, 0.08)',
  /** 层级3 - 浮层/下拉 */
  md: '0 4px 16px rgba(0, 0, 0, 0.12)',
  /** 层级4 - 模态框 */
  lg: '0 8px 24px rgba(0, 0, 0, 0.15)',
  /** 层级5 - 强调 */
  xl: '0 12px 32px rgba(0, 0, 0, 0.18)',
  /** 内阴影 */
  inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.06)',
  /** 聚焦环 */
  focus: '0 0 0 3px rgba(102, 126, 234, 0.25)',
} as const;

/**
 * 特殊阴影效果
 */
export const specialShadows = {
  /** 彩色阴影 - 主色 */
  primaryGlow: '0 8px 24px rgba(102, 126, 234, 0.3)',
  /** 彩色阴影 - 成功 */
  successGlow: '0 8px 24px rgba(16, 185, 129, 0.3)',
  /** 彩色阴影 - 警告 */
  warningGlow: '0 8px 24px rgba(245, 158, 11, 0.3)',
  /** 彩色阴影 - 错误 */
  errorGlow: '0 8px 24px rgba(239, 68, 68, 0.3)',
  /** 卡片悬浮 */
  cardHover: '0 12px 28px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08)',
} as const;

/**
 * 模糊效果
 */
export const blur = {
  /** 无模糊 */
  none: '0',
  /** 轻微模糊 */
  sm: '4px',
  /** 标准模糊 */
  base: '8px',
  /** 中等模糊 */
  md: '12px',
  /** 强模糊 */
  lg: '16px',
  /** 超强模糊 */
  xl: '24px',
} as const;

/**
 * 背景模糊（玻璃态效果）
 */
export const backdropBlur = {
  none: 'none',
  sm: 'blur(4px)',
  base: 'blur(8px)',
  md: 'blur(12px)',
  lg: 'blur(16px)',
  xl: 'blur(24px)',
} as const;

/**
 * 透明度
 */
export const opacity = {
  /** 0 - 完全透明 */
  transparent: 0,
  /** 0.05 */
  5: 0.05,
  /** 0.10 */
  10: 0.1,
  /** 0.20 */
  20: 0.2,
  /** 0.40 */
  40: 0.4,
  /** 0.60 */
  60: 0.6,
  /** 0.80 */
  80: 0.8,
  /** 0.90 */
  90: 0.9,
  /** 1 - 完全不透明 */
  full: 1,
} as const;

/**
 * 导出所有效果
 */
export const effects = {
  borderRadius,
  boxShadow,
  specialShadows,
  blur,
  backdropBlur,
  opacity,
} as const;

export default effects;
